export function moveSetTrack(tracks, from, to) {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= tracks.length ||
    to >= tracks.length
  )
    return tracks;
  const ordered = [...tracks];
  const [moved] = ordered.splice(from, 1);
  ordered.splice(to, 0, moved);
  return ordered.map((track, index) => ({ ...track, position: index + 1 }));
}

export function nextSetName(sets) {
  const names = new Set(sets.map((set) => set.name));
  let name = "Untitled";
  let suffix = 2;
  while (names.has(name)) name = `Untitled ${suffix++}`;
  return name;
}
